import React from "react";

import { css, cx } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { FontSizes } from "@/assets/fonts.ts";
import { Icons } from "@/assets/icons.ts";
import { useStyles } from "@/hooks/useStyles.ts";
import { Queries } from "@/queries/Queries.ts";
import { Button } from "@/uiKit/atoms/Button.tsx";
import { ButtonGroup } from "@/uiKit/atoms/ButtonGroup.tsx";

export type NursePreinclusionActionsProps = {
  onClickReinclusion: () => void;
  onClickHistory: () => void;
  className?: string;
};

export const NursePreinclusionActions: React.FC<NursePreinclusionActionsProps> = ({
  className,
  onClickReinclusion,
  onClickHistory,
}) => {
  const styles = useStyles(makeStyles);
  const { t } = useTranslation();
  const { data: featureFlags } = Queries.user.useFeatureFlags({});

  if (!featureFlags?.["nurse-preinclusion"]) {
    return null;
  }

  return (
    <ButtonGroup variant="contained" className={cx(styles.root, className)}>
      <Button
        id="nurse-preinclusion-button"
        className={styles.reinclusionButton}
        variant="contained"
        data-action="patients.preinclusion.start"
        startIcon={<Icons.userPlus className={styles.icon} />}
        onClick={onClickReinclusion}
      >
        {t("pages.patients.addNurseInclusion")}
      </Button>
      <Button variant="contained" data-action="patients.preinclusion.open-history" onClick={onClickHistory}>
        <Icons.timeRewind className={styles.icon} />
      </Button>
    </ButtonGroup>
  );
};

const makeStyles = () => ({
  root: css({}),
  reinclusionButton: css({
    alignSelf: "center",
    textWrap: "nowrap",
  }),
  icon: css({
    width: FontSizes.body,
    height: FontSizes.body,
  }),
});
